import closeItemReadingPane from '../actions/closeItemReadingPane';
import { getReadingPaneStore } from '../store/Store';
import { mutator } from 'satcheljs';

export default mutator(
    closeItemReadingPane,
    function closeItemReadingPaneMutator(actionMessage: {}) {
        getReadingPaneStore().itemReadingPaneViewState = null;
    }
);
